import React from "react";

const Header = (props)=>{

    const {
        canClear,
        clear,
    } = props;



    return(
        <div className='header flex'>
            <h1>{abraStr.title}</h1>
            <p
                className={`clear ${canClear? "on" : ""}`}
                onClick={clear}
            >
                {abraStr.clear}
            </p>

        </div>
    );
}

export default Header;